// The agency portal uses the admin backend API. Set REACT_APP_API_KEY when
// building on the server so it matches the production backend configuration.
export const baseURL =
  process.env.REACT_APP_API_BASE_URL || "https://admin.rajpatelkinglive.com/";
export const key = process.env.REACT_APP_API_KEY || "";

    
